import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level3Illustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3771">
      <div className="relative w-full h-full bg-gradient-to-b from-lime-100 to-green-300 overflow-hidden" data-id="element-3772">
        {/* Background: Sprout hill */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3773">
          <circle cx="160" cy="40" r="22" fill="#FEF08A" data-id="element-3774" />
          <path d="M0 165 Q100 130 200 165 L200 200 L0 200 Z" fill="#4ADE80" data-id="element-3775" />
          {/* Small sprout */}
          <path d="M100 165 L100 140" stroke="#16A34A" strokeWidth="3" strokeLinecap="round" data-id="element-3776" />
          <path d="M100 150 Q88 142 84 150 Q92 156 100 150 Z" fill="#22C55E" data-id="element-3777" />
          <path d="M100 145 Q112 137 116 145 Q108 151 100 145 Z" fill="#22C55E" data-id="element-3778" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[6%]" data-id="element-3779">
          <div className="w-[60%] h-[60%] flex items-center justify-center" data-id="element-3780">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'happy' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3781" />
          </div>
        </div>

        {/* Foreground: level badge */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3782">
            <circle cx="40" cy="40" r="18" fill="#16A34A" data-id="element-3783" />
            <text x="40" y="46" textAnchor="middle" fontFamily="sans-serif" fontSize="16" fontWeight="900" fill="white" data-id="element-3784">
              3
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}